import {createSlice} from "@reduxjs/toolkit";

const initialSchEducationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  schEducationForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const schEducationsSlice = createSlice({
  name: "schEducations",
  initialState: initialSchEducationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSchEducationById
    schEducationFetched: (state, action) => {
      state.actionsLoading = false;
      state.schEducationForEdit = action.payload.schEducationForEdit;
      state.error = null;
    },
    // findSchEducations
    schEducationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createSchEducation
    schEducationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.schEducation);
    },
    // updateSchEducation
    schEducationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schEducationId === action.payload.schEducation.schEducationId) {
          return action.payload.schEducation;
        }
        return entity;
      });
    },
    // deleteSchEducation
    schEducationDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schEducationId !== action.payload.schEducationId);
    },
    // deleteSchEducations
    schEducationsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schEducationId)
      );
    },
  }
});
